import chalk from 'chalk';
// import fs from 'fs'
// import path from "path";
// import { showFile } from "./console";
// import { getFormattedDate } from "./datetime";
// import { readVariableValue } from "./variablesHelper";
// import { getGlobalConfig } from "./cluserHelper";
export function symbol(
  symbol: 'error' | 'success' | 'warning' | 'begin' | 'info',
) {
  switch (symbol) {
    case 'error':
      return chalk.red('✗');
    case 'warning':
      return chalk.yellow('⚠︎');
    case 'success':
      return chalk.green('✓');
    case 'begin':
      return chalk.green('☆');
    case 'info':
      return chalk.gray('ⓘ');
  }
}

export function successSymbol() {
  return symbol('success');
}

export function errorSymbol() {
  return symbol('error');
}

export function warningSymbol() {
  return symbol('warning');
}

export function beginSymbol() {
  return symbol('begin');
}

export function infoSymbol() {
  return symbol('info');
}

export function log(
  type: 'error' | 'success' | 'warning' | 'begin' | 'info',
  event: string,
  message: string,
) {
  var messageType = type.replace(/\b\w/g, (l) => l.toUpperCase());
  event = event.toLowerCase().replace(/\s/g, '-');

  //  const cfg = getGlobalConfig();
  //  const logFilePath = path.join(cfg.logPath, `log-${entityType}-${infoType}-${getFormattedDate()}.log`);
  // entityType = entityType.toLowerCase().replace(/\s/g, '-');
  //  const logContent = `================================================

  // Entity: ${readVariableValue(entityName)} (${readVariableValue(entityId)})
  // Path: ${entityFilePath}
  // Error: ${message}\n\nStackTrace:\n${stackTrace}

  // `;
  //         // append the logContent to the logFilePath
  //       fs.appendFileSync(logFilePath, logContent);
  var color = chalk.red;
  var symbol = '✗';
  switch (type) {
    case 'error':
      color = chalk.red;
      symbol = '✗';
      break;
    case 'warning':
      color = chalk.yellow;
      symbol = '⚠︎';
      break;
    case 'success':
      color = chalk.green;
      symbol = '✓';
      break;
    case 'begin':
      color = chalk.green;
      symbol = '☆';
      break;
    case 'info':
      color = chalk.gray;
      symbol = 'ⓘ';
      break;
  }
  console.log(`${color(symbol)} ${messageType} ${event}: ${message}`);
}

export function error(event: string, message: string) {
  log('error', event, message);
}

export function success(event: string, message: string) {
  log('success', event, message);
}
export function warning(event: string, message: string) {
  log('warning', event, message);
}

export function begin(event: string, message: string) {
  log('begin', event, message);
}

export function info(event: string, message: string) {
  log('info', event, message);
}
